import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
// css
import classes from "./PDFView.module.css";
import { configurePdfWorker } from "../../../utils/configurePdfWorker";
import { resolveMediaUrl } from "../../../utils/mediaUrl";

configurePdfWorker(pdfjs);

const PDFView = ({ fileSrc,  scaleDoc = 1.2, customWrapperClass }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    setCurrentPage(1);
    setNumPages(null);
    setLoadError("");
  }, [fileSrc]);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < numPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const normalizedFileSrc = resolveMediaUrl(fileSrc);
  const fileName = normalizedFileSrc
    ? normalizedFileSrc.split("/").pop()?.split("?")[0]
    : "";

  return (
    <div className={`${classes.pdfWrapper} ${customWrapperClass}`}>
      <p>{fileName}</p>
      <Document
        file={normalizedFileSrc}
        onLoadSuccess={({ numPages }) => {
          setNumPages(numPages);
          setLoadError("");
        }}
        onLoadError={(error) => {
          console.error("PDF load error:", error);
          setLoadError("Failed to load PDF file.");
        }}
        loading={<p>Loading PDF...</p>}
      >
        {!loadError && (
          <Page pageNumber={currentPage} className={classes.pdfPage} scale={viewportWidth < 768 ? 0.8 : scaleDoc} />
        )}
      </Document>

      <div className={classes.pdfBtn}>
        <p>
          {loadError ? loadError : `${currentPage} - ${numPages} Pages`}
        </p>
        <div className={classes.flex}>
          <Button className={classes.button} onClick={handlePrevPage} disabled={!!loadError || currentPage <= 1}>
            <ArrowLeft
              sx={{
                fontSize: "2.4rem",
                color: "#000",
              }}
            />
          </Button>
          <Button className={classes.button} onClick={handleNextPage} disabled={!!loadError || !numPages || currentPage >= numPages}>
            <ArrowRight
              sx={{
                fontSize: "2.4rem",
                color: "#000",
              }}
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PDFView;
